module.exports = __webpack_public_path__ + "static/media/no-thumbnail.6b544f99.jpg";